import EventsSecretScreen from './EventsSecretScreen';

export default EventsSecretScreen;
